module.exports = __webpack_public_path__ + "img/fp.ace59423.png";